<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">充值管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">充值列表</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>

        <div class="clue-search">
            <div class="left">

                <a-button type="primary" @click="addblack">添加充值套餐</a-button>

                <!-- <a-button type="primary" @click="openimport">导入数据</a-button> -->

                <a-button type="danger" @click="delusers" >删除</a-button>

            </div>
            <!-- 来源 -->

            <div class="right">
                <a-input-search
                    placeholder="关键字（手机号码）"
                    enter-button="查询"
                    @search="onSearch"
                    v-model="searchtext"
                    >
                   
                </a-input-search>
            </div>
             
        </div>

        <div class="data-list">
            <a-spin :spinning="tablespinning">
                <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  rowKey="id" :pagination="pageshow" :columns="columns" :data-source="data">
                    <router-link slot="name" slot-scope="text,record" :to="{path:'cluedetail',query: {id:record.usxsid}}" >
                        {{ text }}
                    </router-link>

    
                    <span slot="action" slot-scope="text,record">
                        
                        <a href="javascript:;" @click="tokehu(record.id)" ><a-icon type="edit" /> 编辑</a>
                        <a href="javascript:;"  style="margin-left:5px" @click="delclue(record.id)"><a-icon type="delete"/> 删除</a>
                    </span>

                    <span slot="date" slot-scope="text">
                        <span v-if="text">{{text | formatDate }}</span>
                        <span v-else>--</span>
                    </span>
                </a-table>

                <div style="padding-top:30px;width: auto;display: flex;align-items: center;justify-content: flex-start;margin: 15px 12px 12px;">
                    <div class="page-total">总计：{{pagination.total}}条 / {{totalpage}}页</div>
                    <a-pagination
                    show-size-changer
                    :default-current="1"
                    :page-size-options="pageSizeOptions"
                    :total="pagination.total"
                    :defaultPageSize="10"
                    @change="handleTableChange"
                    @showSizeChange="onShowSizeChange"
                    >
                        <template slot="buildOptionText" slot-scope="props">
                            <span>{{ props.value }}条/页</span>
                        </template>

                    </a-pagination>
                </div>
            </a-spin>
        </div>

        <!-- 编辑充值套餐 -->
        <a-modal
        title="编辑充值套餐"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="khhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="套餐标题">
                    <a-input v-model="editinfo.title" placeholder="请输入套餐标题"></a-input>
                </a-form-item>
                <a-form-item label="套餐时间(月)">
                    <a-input-number id="inputNumber" v-model="editinfo.months" :min="1"  />
                </a-form-item>
                <a-form-item label="套餐价格">
                    <a-input type="number" v-model="editinfo.money" placeholder="请输入套餐价格"></a-input>
                </a-form-item>

        
            </a-form>
        </a-modal>

        <!-- 添加充值套餐 -->
        <a-modal
        title="添加充值套餐"
        :visible="addvisible"
        cancelText="取消"
        okText="确认"
        @ok="addhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="套餐标题">
                    <a-input v-model="title" placeholder="请输入套餐标题"></a-input>
                </a-form-item>
                <a-form-item label="套餐时间(月)">
                    <a-input-number id="inputNumber" v-model="months" :min="1"  />
                </a-form-item>
                <a-form-item label="套餐价格">
                    <a-input type="number" v-model="money" placeholder="请输入套餐价格"></a-input>
                </a-form-item>

    
            </a-form>
        </a-modal>



    </div>
    
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import md5 from 'js-md5'
import { Modal } from 'ant-design-vue';
// import 'moment/locale/zh-cn';
 import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
 import VDistpicker from 'v-distpicker'
 Vue.component('v-distpicker',VDistpicker)
moment.locale('zh-cn');
import addresslist from '../../../static/address.json'
Vue.prototype.$moment = moment
import {formatDate} from '../../utils/formate.js'
const columns = [
    {title: 'ID',dataIndex: 'id',key: 'id',fixed: 'left',width:'130px'},
    {title: '套餐标题',dataIndex: 'title',key: 'title'},
    {title: '套餐时间（月）',dataIndex:'months',key: 'months'},
    {title: '套餐价格',dataIndex:'money',key: 'money'},

    {title: '操作',key: 'action',scopedSlots: { customRender: 'action' },fixed: 'right',width:160},
];

export default {
    filters: {
      //年-月-日
        formatDate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd')
        },
        topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        const adddata = [];
        return{
            locale,
            show:true,
            searchtext:"",
            tstext:"",
            tablespinning:true,
            tabley:"",
            tablex:"100%",
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
            columns,
            data:{},
            pagination:{},
            size:10,
            totalpage:"",
            pageshow:false,
            currentpagination:"",
            pageSizeOptions:['10','20','30','40','100','200'],

        
            // gjvisible:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),

            center:"center",

            usxsid:"",
            isvalid:0,


        

            selectedRowKeys: [],

            buttonshow:true,
            editvisible:false,
            addvisible:false,

            disabled:true,

            editinfo:"",
            title:"",
            months:"",
            money:"",
            editid:""
        }
    },
    watch: {
      windowHeight (val) {
        this.tabley=val*0.56
      },
    },

    mounted(){
       this.fetch()

        window.fullHeight = document.documentElement.clientHeight;
        this.windowHeight = window.fullHeight;  
        this.tabley=this.windowHeight*0.56
         // <!--把window.onresize事件挂在到mounted函数上-->
        window.onresize = () => {
            return (() => {
                window.fullHeight = document.documentElement.clientHeight;
                this.windowHeight = window.fullHeight;  // 高
                this.tabley=this.windowHeight*0.56
            })()
        };
    },
    methods:{
     
        // 删除
        delusers(){
            if(this.selectedRowKeys.length==0){
                this.$message.error("请选择数据");
            }{
                var id=this.selectedRowKeys.join(",")
                Modal.confirm({
                    title: '提示',
                    content: '您确定删除吗?',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk:() => {
                        this.handok(id)
                    },
                    onCancel() {

                    },
                });
            }
           
        },
        delclue(value){
            Modal.confirm({
                title: '提示',
                content: '您确定删除吗?',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk:() => {
                    this.handok(value)
                },
                onCancel() {

                },
            });
        },
        handok(value){
            this.$axios.post('/api/setmeal/delsetmeal',{
                ids:value
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    this.$message.success('删除成功');
                    // this.disabled=true
                    this.selectedRowKeys=[]
                    this.fetch()
                }else{
                    this.$message.error(res.data.msg);
                }
            })
        },

        importhandleCancel(){
            this.importvisible=false
        },

        

        // 多选框
        onSelectChange(selectedRows){
            // console.log(selectedRows)
            this.selectedRowKeys = selectedRows;

        },


        // 号码查询
        onSearch(){
            this.fetch()
        },

        // 分页
        handleTableChange(pageNumber) {
            this.currentpage=pageNumber
            this.fetch();
        },
        onShowSizeChange(current,pageSize){
            this.size=pageSize
            this.page=1
            this.fetch();
        },

        // 数据
        fetch(params = {}){
            this.$axios.post('/api/setmeal/setmeallist',{
                pagesize: this.size,
                page:this.currentpage,
                search:this.searchtext,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.tablespinning=false
                    const pagination = { ...this.pagination };
                    pagination.total = res.data.data.total;
                    pagination.pageSize=this.size
                    this.data=res.data.data.data
                    this.pagination = pagination;
                    this.totalpage=Math.ceil(res.data.data.total/this.size)
                }else{

                }
               
            })
        },
        // 添加
        addblack(){
            this.addvisible=true
        },
        addhandleOk(){
            this.$axios.post('/api/setmeal/addsetmeal',{
                id:this.editid,
                title:this.title,
                months:this.months,
                money:this.money
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.addvisible=false
                    this.title=""
                    this.months=""
                    this.money=""
                    this.fetch()
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        handleCancel(){
            this.editvisible=false
            this.addvisible=false
        },
           // 编辑
        tokehu(id){
            this.editvisible=true
            this.editid=id
            this.getdetail(id)
        },
        getdetail(id){
             this.$axios.post('/api/setmeal/setmealpage',{
                id:id
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editinfo=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },

        khhandleOk(){
            this.$axios.post('/api/setmeal/editsetmeal',{
                id:this.editid,
                title:this.editinfo.title,
                months:this.editinfo.months,
                money:this.editinfo.money
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.editvisible=false
                    this.fetch()
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },


    }
}
</script>


// WEBPACK FOOTER //
// src/components/renew/renew.vue